import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function Guarantee() {
  return <AnimatedSection className="py-12 sm:py-16" data-id="element-88">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="bg-gradient-to-b from-navy-900 to-dark-card border border-gold/30 rounded-2xl p-6 sm:p-8 md:p-12 text-center relative overflow-hidden" data-id="element-90">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10" data-id="element-91">
            <ShieldCheck size={120} className="text-gold sm:w-[200px] sm:h-[200px]" data-id="element-92" />
          </div>

          <div className="relative z-10" data-id="element-93">
            <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gold/10 border border-gold/30 mb-5 sm:mb-6" data-id="element-94">
              <ShieldCheck size={32} className="text-gold sm:w-10 sm:h-10" data-id="element-95" />
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-white mb-5 sm:mb-6 leading-tight" data-id="element-96">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="text-base sm:text-lg text-gray-300 space-y-3 sm:space-y-4 mb-6 sm:mb-8 leading-relaxed" data-id="element-97">
              <p data-id="element-98">
                Abrís los tomos. Los usás para estudiar o en la práctica
                clínica.
              </p>
              <p data-id="element-99">Si en 7 días no es lo que esperabas:</p>
              <p className="text-xl sm:text-2xl font-bold text-white" data-id="element-100">
                devolución del 100%
              </p>
              <p data-id="element-101">sin formularios, sin drama, sin preguntas raras.</p>
            </div>

            <div className="inline-block bg-navy-950 border border-dark-border rounded-full px-5 py-2 sm:px-6 text-xs sm:text-sm text-gray-400" data-id="element-102">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}